import React, {useState} from "react";
import CustomSelect from "../../../utils/CustomSelect/CustomSelect";
import closeIcon from "../../../img/closeIcon.svg";
import useAuth from "../../../utils/CustomHooks/useAuth/useAuth";

const NoOptionsEditElementDictionary = (props) => {

    const {
        onHandleConfirmEditElementDictionary,
        onCloseModal,
        isModalMessage
    } = props;

    const { dictionaryCountries, dictionaryVessels } = useAuth();
    const [isNameElement, setNameElement] = useState('');
    const [isSelectedItemDictionary, setSelectedItemDictionary] = useState(null);

    const optionDestinationCountry = dictionaryCountries.map(el => ({
        "value": el?.id,
        "label": el?.name
    }))

    const optionVessels = dictionaryVessels.map(el => ({
        "value": el?.id,
        "label": el?.name
    }))

    return (
        <div className="no-option-add-element-dictionary-modal__container">
            <div className="no-option-add-element-dictionary-modal">
                <div className="no-option-add-element-dictionary-modal__title">
                    <h3>Edit vessel</h3>
                    <img onClick={() => onCloseModal()} src={closeIcon} alt={'иконка крестик'}/>
                </div>
                <div className="no-option-add-element-dictionary-modal-input-block">
                    <label className="no-option-add-element-dictionary-modal-input-block__label">Select vessel for editor</label>
                    <CustomSelect className="no-option-add-element-dictionary-modal-input-block__select-input"
                                  options={optionVessels}
                                  value={isNameElement}
                                  onChange={value => setNameElement(value)}
                    />
                </div>
                <div className="no-option-add-element-dictionary-modal-input-block">
                    <label className="no-option-add-element-dictionary-modal-input-block__label">Select country</label>
                    <CustomSelect className="no-option-add-element-dictionary-modal-input-block__select-input"
                                  options={optionDestinationCountry}
                                  value={isSelectedItemDictionary}
                                  onChange={value => setSelectedItemDictionary(value.value)}
                    />
                    <p className="no-option-add-element-dictionary-modal-input-block__error-message">{isModalMessage}</p>
                </div>
                <div className="no-option-add-element-dictionary-modal__buttons-block">
                    <button onClick={() => onCloseModal()} className="no-option-add-element-dictionary-modal__button-cancel" type={"button"}>Cancel</button>
                    <button onClick={() => onHandleConfirmEditElementDictionary(isNameElement, isSelectedItemDictionary)}  className="no-option-add-element-dictionary-modal__button-create" type={"button"}>Save</button>
                </div>
            </div>
        </div>
    )
}
export default NoOptionsEditElementDictionary;